const NCBISvg = () => (
  <svg
    enableBackground='new 0 0 392.164 484.439'
    viewBox='0 0 392.164 484.439'
    x='0px'
    xmlSpace='preserve'
    y='0px'
  >
    <g>
      <g>
        <path
          d='M197.84,68.301c-54.555,6.117-139.949,33.596-37.947,76.346c49.816,21.375-120.973-42.75,37.947-54.963'
          fill='#231F20'
        />
        <path
          d='M195.471,272.91c54.555-6.117,139.957-36.646,37.955-79.396c-49.816-21.382,120.973,45.802-37.955,54.963'
          fill='#231F20'
        />
        <path
          d='M195.471,156.867c158.928-9.162-11.861-76.346,37.955-54.971c102.002,42.75,16.6,73.294-37.955,79.396
			h4.746c-158.928,9.162,9.492,73.295-40.324,51.92c-99.626-42.758-16.607-70.242,40.324-76.346'
          fill='#231F20'
        />
        <path
          d='M197.84,65.25c-56.925,6.109-139.949,33.596-40.316,76.346c52.186,21.375-118.604-42.75,40.316-51.912'
          fill='#FFFFFF'
        />
        <path
          d='M193.102,269.852c56.924-6.109,139.949-36.639,40.324-79.396c-49.816-21.375,118.603,45.809-40.324,54.963
			'
          fill='#FFFFFF'
        />
        <path
          d='M195.471,153.815c156.558-9.169-11.861-76.345,37.955-54.97c99.625,42.75,16.6,73.286-40.324,79.396h4.738
			c-158.92,9.162,11.869,73.287-37.947,51.912c-102.002-42.75-16.607-70.236,37.947-76.339'
          fill='#FFFFFF'
        />
      </g>
    </g>
    <g>
      <path
        d='M76.217,382.443c2.42-1.383,2.881-2.073,3.571-5.99c2.074-12.097,3.341-40.667,3.341-47.35
		c0-9.446-0.114-9.331-2.188-11.75c-2.995-3.687-5.069-4.724-6.566-5.185v-0.461c2.765,0.346,5.99,0.461,8.295,0.461
		c2.649,0,5.99-0.23,7.604-0.461c15.552,23.502,33.179,42.165,46.427,57.372c0.115-1.498,0.115-9.102,0.115-14.977
		c-0.23-15.553-0.576-32.948-2.188-38.018c-0.807-2.419-1.959-3.571-3.457-3.917v-0.461c3.111,0.23,6.567,0.461,9.908,0.461
		c3.11,0,4.838-0.23,6.566-0.461v0.461c-1.613,0.576-2.419,1.383-3.226,4.493c-1.729,6.336-3.917,53.224-4.493,66.242
		c-0.576-0.115-1.152-0.115-1.728-0.115c-0.691,0-1.268,0-1.844,0.115c-14.4-16.475-37.441-42.741-48.731-57.947l-0.23,0.23
		c0.115,7.948,0.576,38.823,2.189,51.841c0.346,2.996,0.807,4.378,2.88,5.415v0.461c-2.765-0.346-5.53-0.461-8.295-0.461
		c-2.649,0-5.299,0.23-7.949,0.461V382.443z'
        fill='#FFFFFF'
      />
      <path
        d='M212.96,328.759c0-2.074-0.23-4.263-2.419-6.337c-4.608-4.263-12.673-5.76-17.051-5.76
		c-6.682,0-11.29,0.691-14.861,2.765c-7.373,4.378-8.985,16.82-8.985,24.884c0,21.773,12.787,30.299,29.146,30.299
		c9.907,0,15.782-4.147,18.663-6.451c0.461,0.807,1.151,1.728,1.497,2.073c-5.645,4.839-7.834,7.488-11.636,12.558
		c-2.304,0.576-3.917,1.152-10.022,1.152c-21.658,0-37.441-12.558-37.441-35.944c0-23.731,16.705-37.326,39.17-37.326
		c8.64,0,15.092,1.844,17.972,1.844h1.151c-1.497,2.995-3.341,8.871-3.341,16.244H212.96z'
        fill='#FFFFFF'
      />
      <path
        d='M254.775,383.941c-1.959,0-4.954-0.346-7.719-0.807c-2.881-0.346-5.646-0.691-7.373-0.691
		c-2.189,0-8.295,0.346-9.332,0.461v-0.461c1.729-0.23,3.226-1.844,3.802-4.954c0.691-3.687,1.268-10.368,1.268-30.183
		c0-31.451-1.152-34.216-5.069-35.138v-0.461c0.576,0,2.305,0.115,4.263,0.23c1.959,0.115,4.032,0.23,5.069,0.23
		c1.958,0,5.184-0.346,8.755-0.807c3.571-0.346,7.604-0.691,11.06-0.691c12.097,0,18.202,4.839,18.202,14.632
		c0,7.718-5.529,12.787-12.672,18.547c6.566,0.807,18.663,4.724,18.663,17.512c0,5.76-1.959,10.829-5.991,14.285
		C271.479,381.061,265.604,383.941,254.775,383.941z M244.752,316.086c-0.691,4.608-0.691,14.631-0.691,27.188
		c3.688,0,15.207,0,16.705-0.346c2.073-1.613,7.143-5.876,7.143-13.134c0-9.446-6.221-14.516-15.783-14.516
		C249.591,315.279,247.172,315.625,244.752,316.086z M244.061,347.191c0,7.948,0,20.852,0.691,27.994
		c3.11,1.729,7.949,4.147,15.322,4.147c4.378,0,7.949-1.037,9.793-2.419c2.995-2.189,4.031-8.525,4.031-11.29
		c0-11.636-8.524-18.778-20.736-18.778C250.167,346.846,246.135,347.191,244.061,347.191z'
        fill='#FFFFFF'
      />
      <path
        d='M315.254,312.169c-4.147,1.037-5.068,4.493-5.068,35.138c0,31.45,1.151,34.1,5.068,35.137v0.461
		c-1.037-0.115-7.143-0.461-9.446-0.461c-2.189,0-8.295,0.346-9.332,0.461v-0.461c4.032-0.922,5.069-4.493,5.069-35.137
		c0-31.105-1.152-34.216-5.069-35.138v-0.461c1.037,0.115,7.143,0.461,9.332,0.461c2.304,0,8.409-0.346,9.446-0.461V312.169z'
        fill='#FFFFFF'
      />
    </g>
  </svg>
)

export default NCBISvg
